import { render, staticRenderFns } from "./ModalSlideUp.vue?vue&type=template&id=c874ed32&scoped=true&"
import script from "./ModalSlideUp.vue?vue&type=script&lang=js&"
export * from "./ModalSlideUp.vue?vue&type=script&lang=js&"
import style0 from "./ModalSlideUp.vue?vue&type=style&index=0&id=c874ed32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c874ed32",
  null
  
)

component.options.__file = "ModalSlideUp.vue"
export default component.exports